export const MAX_ENTITY_NAME = 56;
export const MAX_ENTITY_DESCRIPTION = 500;
